import React from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { FullViewProps } from '../types';
import { VideoPlayer } from '../../../VideoPlayer/LoadableVideoPlayer';
import DeviationMediaService from '../../../utils/DeviationMediaService';
import { getSource } from '../../_helpers';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import LoadablePlayer from './LoadablePlayer';

import s from './Film.scss';

export const FilmFullView: React.FC<FullViewProps> = ({
  deviation,
  height,
  width,
}) => {
  const videoFile = getSource(
    DeviationMediaService.getMediaByType(deviation, 'video')
  );

  const previewFile = DeviationMediaService.getDeviationFile(
    deviation,
    'preview'
  );

  const isNewVideoPlayer = useFlag('new_video_player');

  if (!videoFile) {
    return null;
  }

  if (isNewVideoPlayer) {
    return (
      <ErrorBoundary debugComponent="FilmFullView">
        {previewFile && (
          <link rel="preload" href={previewFile.src} as="image" />
        )}
        <link
          rel="preload"
          href={videoFile.src}
          as="video"
          crossOrigin="anonymous"
        />
        <div className={s['root']} style={{ width, height }}>
          <LoadablePlayer
            src={videoFile.src}
            poster={previewFile?.src}
            autoplay
            muted
            loop={videoFile.duration && videoFile.duration > 60 ? false : true}
          />
        </div>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary debugComponent="FilmFullView">
      {previewFile && <link rel="preload" href={previewFile.src} as="image" />}
      <link rel="preload" href={videoFile.src} as="video" />
      <div>
        <div className={s['root']} style={{ width, height }}>
          <VideoPlayer
            width={width}
            height={height}
            src={videoFile.src}
            loadingCover={previewFile && previewFile.src}
            autoPlay
            muted
          />
        </div>
      </div>
    </ErrorBoundary>
  );
};
FilmFullView.displayName = 'FilmFullView';

export default FilmFullView;
